import React, {Component} from 'react';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    prepareSelectOptionsList,
    actionsFormatter,
    historyDataFormatter,
    dateFormatter,
    customFormatter,
    getFieldByPathFormatter
} from 'util/Utils';
import moment from 'moment'
  import config from  '../../../config';
import {Link} from "react-router";
import { Button, Col} from "react-bootstrap";


class AdminScheduledDeliveriesTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            currentTab: {},
            adminFulfillments: [

            ],
        };
    }






    customActionsFormatter(cell, row, extra) {

             return   <div>

                    <div>
                        <Button bsStyle="link">
                            <Link className="underlineText"
                                  onClick={() =>this.props.prepareMultipleOrdersScreen( row,'EditScheduledDeliveriesScreen',)
                                     }>Edit</Link>
                        </Button>
                    </div>



                </div>
        }





    render() {
        // console.log('props', this.props  );
        return (
            <div className=" databases-table">
                <BootstrapTable data={this.props.tableData} ref='table'
                                remote={true}
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } } >
                    <TableHeaderColumn  width="100px" dataField="id" isKey={true}  hidden={true} autoValue={ true } hiddenOnInsert>Id</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataAlign="center" dataField="SaleData.OrderNumber"
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: 'getObject',


                                               format: (row) => {
                                                   return  <div>

                                                       <a target="_blank" className=""
                                                          href={ config.getEnvironment().shopify.orderUrlTemplate.replace("[link_value]", row.SaleData['OrderID']) }>{_.get(row,'SaleData.OrderNumber', 'n/a')}</a>
                                                       {_.size(_.get(row, 'ConnectedTransactionsData.ConnectedTransactions', [])) > 0 &&

                                                       <div className="top10">

                                                           { _.map(_.reject(_.get(row, 'ConnectedTransactionsData.ConnectedTransactions', []),item=>{
                                                                      return _.get(item,'ShopifyOrderNumber')==_.get(row,'SaleData.OrderNumber')}), item => {
                                                               return   <a key={row.ShopifyOrderID} target="_blank" className="pleft5 pink" href={ config.getEnvironment().shopify.orderUrlTemplate.replace("[link_value]",item.ShopifyOrderID) }>{_.get(item,'ShopifyOrderNumber', 'n/a')}</a>
                                                           })  }

                                                       </div>

                                                       }
                                                   </div>

                                               }
                                           }}

                                       dataSort={true}    >Order №</TableHeaderColumn>


                    <TableHeaderColumn width="40px" dataField="SaleData.OrderCreateDate" dataAlign="center"
                                       dataFormat={ dateFormatter }
                                       editable={ false }
                                       formatExtraData={ {'path': 'SaleData.OrderCreateDate', 'format': 'MM/DD'} }
                                       dataSort={true}>Order Date</TableHeaderColumn>
                    <TableHeaderColumn width="100px"
                                       editable={ false }    dataFormat={ dateFormatter }
                                       formatExtraData={ {'path': 'FulfillByDate', 'format': 'MM/DD'} }

                                       dataField='FulfillByDate' dataAlign="center"
                                       dataSort={true}>Fulfill By</TableHeaderColumn>
                    <TableHeaderColumn width="60px" dataAlign="center"
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'],
                                           format: (record) => {
                                               var deliveryMethod = ''
                                               if (_.get(record, 'WorkWaveEventID')) {
                                                       deliveryMethod = 'GBG'
                                                   } else  if (_.get(record, 'VehoOrderID')) { {
                                                       deliveryMethod = 'Veho'
                                                   }
                                               }

                                                return <div>
                                                   <div>{deliveryMethod}</div>
                                                   { _.map(_.get(record, 'allOrderTransactions', []), (item, index) => {

                                                        return <div key={index}>
                                                       {_.get(item, 'VehoOrderData.PackageID') &&
                                                             <div  className="top10 bot10">
                                                                 <div>
                                                                     {_.get(item, 'VehoOrderData.TrackingID') ?
                                                                     <a target="_blank" className=" "
                                                                        href={ (config.getEnvironmentName() == 'production' ? 'https://track.shipveho.com/#/trackingid/' : 'https://track-sandbox.shipveho.com/#/trackingid/')+_.get(item, 'VehoOrderData.TrackingID')   }>{_.get(item, 'SaleData.ProductName')} </a>
                                                                 :_.get(item, 'SaleData.ProductName')}
                                                              </div>
                                                                    <a target="_blank" className=" "
                                                                      href={ (config.getEnvironmentName() == 'production' ? 'https://api-basic.shipveho.com/v2/labels/' : 'https://api-basic-sandbox.shipveho.com/v2/labels/')+_.get(item, 'VehoOrderData.PackageID')  +'.pdf'  }>{_.get(item, 'VehoOrderData.PackageHeight') + ' x ' +_.get(item, 'VehoOrderData.PackageWidth')+ ' x ' +_.get(item, 'VehoOrderData.PackageLength')} </a>


                                                           </div>
                                                                }
                                                       </div>

                                                   })}
                                               </div>
                                           }}
                                       }
                                       dataField='DeliveryMethod'>Delivery Method</TableHeaderColumn>
                    <TableHeaderColumn width="100px"
                                       editable={ false } dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'],
                                           format: (record) => {
                                               if (_.get(record, 'ShopifyOrderShippingAddress.province_code')) {
                                                   return <div>
                                                       <div>{_.get(record.ShopifyOrderShippingAddress, 'address1', 'n/a') + ' ' + _.get(record.ShopifyOrderShippingAddress, 'address2', 'n/a') + ' ' + _.get(record.ShopifyOrderShippingAddress, 'city', '') + ', ' + _.get(record.ShopifyOrderShippingAddress, 'province_code', '') + ' ' + _.get(record.ShopifyOrderShippingAddress, 'zip', '')}</div>
                                                       {_.get(record.ShopifyOrderShippingAddress, 'phone') &&
                                                       <div
                                                           className="top10">{_.get(record.ShopifyOrderShippingAddress, 'phone')}</div>
                                                       }
                                                   </div>
                                               }}}
                                       }
                                       dataField='ShopifyOrderShippingAddress.province_code' dataAlign="center"
                                       dataSort={true}>Contacts</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataAlign="center" dataField='Status'
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'],
                                           format: (record) => {


                                               if (_.size(_.get(record, 'ConnectedTransactionsData.ConnectedTransactions', []))) {
                                                   var ConnectedTransactionsData = _.reduce(_.get(record, 'ConnectedTransactionsData.ConnectedTransactions', []), function (transactionsData, item) {
                                                       _.forEach(_.get(item, 'Transactions', []), transactionData => {
                                                           transactionsData.push(transactionData)
                                                       })
                                                       return transactionsData
                                                   }, [])
                                                   var transactionsToCheck = _.map(ConnectedTransactionsData, item => {
                                                       return {MarketName:_.get(item,'MarketName'), ClaimedByUserID: _.get(item, 'SaleData.ClaimedByUserID'), ClaimedByUserAt: _.get(item, 'SaleData.ClaimedByUserAt'), ProductState: _.get(item, 'SaleData.ProductState','')}
                                                   })
                                               } else {
                                                   var transactionsToCheck = _.get(record, 'allOrderTransactions', [])
                                                }

                                                 transactionsToCheck = _.filter(transactionsToCheck,item=>{
                                                   var MarketsToCheck = [_.get(this.props, 'searchBoxReference.state.filterOptions.Market', 'n/a')]

                                                     var SubMarkets =_.get(config.warehouseData[ _.get(this.props, 'searchBoxReference.state.filterOptions.Market', 'n/a')],'SubMarkets', [])
                                                     if (SubMarkets.length){
                                                         MarketsToCheck =   _.concat(MarketsToCheck,SubMarkets)
                                                     }
                                                   return _.includes(MarketsToCheck,item.MarketName)
                                               })

                                               var allTransactionsPlucked = transactionsToCheck.length > 0 ? _.every(transactionsToCheck, item => {
                                                   return item.ProductState == 'Plucked' || item.ProductState == 'Packed'
                                               }) : false;
                                               var allTransactionsPacked = transactionsToCheck.length > 0 ? _.every(transactionsToCheck, item => {
                                                   return item.ProductState == 'Packed'
                                               }) : false;
                                               var claimedTransactionExists = transactionsToCheck.length > 0 ? _.some(transactionsToCheck, item => {
                                                   return _.get(item,'ClaimedByUserID') &&  moment().diff(moment(_.get(item, 'ClaimedByUserAt')),'minutes') <120
                                               }) : false;
                                               var status =  'Un-Plucked'
                                               if (allTransactionsPlucked) {
                                                   status =  'Plucked'
                                               }
                                               if (allTransactionsPacked){
                                                   status =  'Packed'
                                               }
                                               return <div>
                                                   <span>{status}</span>
                                                   { claimedTransactionExists  &&
                                                   <div><a href="" className="pleft5  "
                                                           onClick={(e) => {
                                                               e.preventDefault()

                                                               this.props.prepareMultipleOrdersScreen(record, 'RemoveClaimsForTransactions')
                                                           }}
                                                   >Claimed</a></div>
                                                   }
                                               </div>

                                       }}} >Status</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataField="Status" dataAlign="center"
                                       dataFormat={ getFieldByPathFormatter }
                                       editable={ false }
                                       formatExtraData={ {'path': 'Status' } }
                                       dataSort={true}>Status</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataField="SaleData.OrderCreateDate" dataAlign="center"
                                       dataFormat={ dateFormatter }
                                       editable={ false }
                                       formatExtraData={ {'path': 'SaleData.OrderDeliveryDate', 'format': 'MM/DD'} }
                                       dataSort={true}>Delivery Date</TableHeaderColumn>
                    {/*<TableHeaderColumn width="40px" dataField="FulfilledAt" dataAlign="center"*/}
                                       {/*dataFormat={ dateFormatter }*/}
                                       {/*editable={ false }*/}
                                       {/*formatExtraData={ {'path': 'FulfilledAt', 'format': 'MM/DD'} }*/}
                                       {/*dataSort={true}>Fulfilled Date</TableHeaderColumn>*/}
                     <TableHeaderColumn width="50px" dataAlign="center"
                                       editable={ false }
                                       dataFormat={ this.customActionsFormatter.bind(this) }>Actions</TableHeaderColumn>
                </BootstrapTable>

            </div>
        );
    }
}

export default AdminScheduledDeliveriesTable;
